import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthResult } from '@nebular/auth';
import { environment } from '../../../environments/environment';
import { AppAuthService } from '../services/app-auth.service';

@Component({
  selector: 'def-login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class LoginComponent implements OnDestroy {

  alive = true;
  errors: string[] = [];
  credentials: any = {};
  submitted = false;
  resetPasswordUrl = `${environment.exchangeApi.url}reset-password`;

  constructor(
    protected cd: ChangeDetectorRef,
    protected router: Router,
    private appAuth: AppAuthService,
  ) {
    // Internal members are automatically connected because we have not opened the website to external members yet
    this.loginAsIntern();
  }

  loginAsIntern(): Promise<boolean> {
    return this.appAuth.decathConnection();
  }

  loginAsExtern(): void {
    this.errors = [];
    this.submitted = true;

    this.appAuth.submitExternalCredentials(this.credentials)
      .subscribe((result: NbAuthResult) => {
        this.submitted = false;

        if (!result.isSuccess()) {
          this.errors = result.getErrors();
        }
      });
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
